const blankLaserTemplatesEl = document.getElementById('blank_laser_templates');
const blankLaserTemplate = {
    data() {
        return {
        }
    },
    props: ['node'],
    created() {},
    mounted() {},
    computed: {},
    methods: {},
    template: `<tr class="border_btm"><td class="temp-hov item" data-th="Part#">
                    <div class="tooltip"><a :href="'/products/' + node.handle">{{node.handle}}</a>
                        <div class="tooltiptext">
                            <div class="hover-box-inner"><h4>{{node.title}}</h4>
                                <div class="two_collmn-box">
                                    <div class="left-side-box">
                                        <a :href="'/products/' + node.handle">
                                            <img :src="node.image.url" :width="node.image.width" :height="node.image.height" alt="">
                                        </a>
                                        <div class="view-btn"><a :href="'/products/' + node.handle">View Detail</a></div>
                                    </div>
                                    <div class="right-side-box" v-html="node.description"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </td>
                <td data-th="Width">{{node.width}}</td>
                <td data-th="Height">{{node.length}}</td>
                <td data-th="Shape">{{node.shape}}</td>
                <td data-th="Perforation">{{node.perforated}}</td>
                <td data-th="Labels/Sheet">{{node.labels_per_sheet}}</td>
                <td data-th="Download PDF"><a v-if="node.pdf_link" class="wordicon1" target="_blank" :href="node.pdf_link"><img src="https://cdn.shopify.com/s/files/1/0516/8109/9933/files/pdf_icon_2c861adb-73b0-43c1-8ab0-71291b27ccac.png" alt="PDF"></a></td>
                <td data-th="Download Word"><a v-if="node.word_link"  class="wordicon1" target="_blank" :href="node.word_link"><img src="https://cdn.shopify.com/s/files/1/0516/8109/9933/files/doc_icon_68cee4ac-362b-463c-a19e-684a10e722d9.png" alt="DOC"></a></td></tr>`
}
const blankLaserTemplatesApp = Vue.createApp({
    components: {
        'blank_laser_template': blankLaserTemplate
    },
    data() {
        return {
            isMounted: false,
            labels: [],
            limit: 6,
            show: {
                'width': null,
                'length': null,
                'shape': null,
                'perforated': null,
                'labels_per_sheet': null,
            },
            filters: {
                'width': [],
                'length': [],
                'shape': [],
                'perforated': [],
                'labels_per_sheet': [],
            },
            searchFilters: {
                'width': null,
                'length': null,
                'shape': null,
                'perforated': null,
                'labels_per_sheet': null,
            },
            selectedFilters: {
                'width': [],
                'length': [],
                'shape': [],
                'perforated': [],
                'labels_per_sheet': [],
            },
            sortFilters: {
                'width': null,
                'length': null,
                'shape': null,
                'perforated': null,
                'labels_per_sheet': null,
            }
        }
    },
    created() {
        this.getLabels();
    },
    mounted() {
        setTimeout(() => {
            this.isMounted = true;
        },100);
    },
    computed: {
        filteredLabels() {
            let sortBy = null;
            let sortByDir = null;
            let sortedLabels = this.cloneObject(this.labels);
            for(const f in this.sortFilters) {
                if(this.sortFilters[f] === 'asc') {
                    sortBy = f;
                    sortByDir = 'asc';
                } else if(this.sortFilters[f] === 'desc') {
                    sortBy = f;
                    sortByDir = 'desc';
                }
            }
            const numericKeys = ['width', 'length', 'labels_per_sheet'];
            const num = (v) => {
                const n = parseFloat(v);
                return isNaN(n) ? Infinity : n;
            };
            const cmp = (a, b, key) => {
                if(numericKeys.includes(key)) {
                    return num(a[key]) - num(b[key]);
                }
                return String(a[key] || '').toUpperCase().localeCompare(String(b[key] || '').toUpperCase());
            };
            // Default order: smallest to largest (width, then height), then part number.
            const bySize = (a, b) => cmp(a, b, 'width') || cmp(a, b, 'length') || String(a.handle).localeCompare(String(b.handle));
            if(sortBy && sortByDir) {
                sortedLabels.sort((a, b) => {
                    const r = cmp(a, b, sortBy);
                    if(r !== 0) {
                        return sortByDir === 'desc' ? -r : r;
                    }
                    return bySize(a, b);
                });
            } else {
                sortedLabels.sort(bySize);
            }
            for(const s in this.selectedFilters) {
                if(this.selectedFilters[s] && this.selectedFilters[s].length > 0) {
                    sortedLabels = sortedLabels.filter((l) => this.selectedFilters[s].includes(l[s]));
                }
            }
            return sortedLabels;
        },
        filterWidth() {
            if(this.searchFilters['width']) {
                return this.filters['width'].sort((x, y) => parseFloat(x) - parseFloat(y)).filter((f) => f.toLowerCase().includes(this.searchFilters['width'].toLowerCase()));
            } else {
                return this.filters['width'].sort((x, y) => parseFloat(x) - parseFloat(y));
            }
        },
        filterHeight() {
            if(this.searchFilters['length']) {
                return this.filters['length'].sort((x, y) => parseFloat(x) - parseFloat(y)).filter((f) => f.toLowerCase().includes(this.searchFilters['length'].toLowerCase()));
            } else {
                return this.filters['length'].sort((x, y) => parseFloat(x) - parseFloat(y));
            }
        },
        filterShape() {
            if(this.searchFilters['shape']) {
                return this.filters['shape'].sort().filter((f) => f.toLowerCase().includes(this.searchFilters['shape'].toLowerCase()));
            } else {
                return this.filters['shape'].sort();
            }
        },
        filterPerforated() {
            if(this.searchFilters['perforated']) {
                return this.filters['perforated'].sort().filter((f) => f.toLowerCase().includes(this.searchFilters['perforated'].toLowerCase()));
            } else {
                return this.filters['perforated'].sort();
            }
        },
        filterLabels() {
            if(this.searchFilters['labels_per_sheet']) {
                return this.filters['labels_per_sheet'].sort((x, y) => parseFloat(x) - parseFloat(y)).filter((f) => f.toLowerCase().includes(this.searchFilters['labels_per_sheet'].toLowerCase()));
            } else {
                return this.filters['labels_per_sheet'].sort((x, y) => parseFloat(x) - parseFloat(y));
            }
        }
    },
    methods: {
        cloneObject(o) {
            return JSON.parse(JSON.stringify(o));
        },
        updateSort(filter) {
            for(const f in this.sortFilters) {
                if(f !== filter) {
                    this.sortFilters[f] = null;
                }
            }
            if(!this.sortFilters[filter]) {
                this.sortFilters[filter] = 'asc';
            } else if(this.sortFilters[filter] === 'asc') {
                this.sortFilters[filter] = 'desc';
            } else {
                this.sortFilters[filter] = null;
            }
        },
        getLabels(after = null) {
            const lolHeaders = new Headers();
            lolHeaders.append("Content-Type", "application/json");
            lolHeaders.append("X-Shopify-Storefront-Access-Token", "a87223acf2d4c59d73f95484844bf0af");

            const query = `query labels($after: String) {
    products(first: 250, after: $after, query: "(product_type:Labels - Laser) AND (tag:'select_material_name:W') AND (tag:'cat:Blank Label Templates')") {
    pageInfo {
        hasNextPage
        endCursor
    }
    edges {
        node {
            id
            handle
            title
            descriptionHtml
            featuredImage {
                url
                width
                height
            }
            metafields(identifiers: [
                {namespace: "labelsonline", key: "width"},
                {namespace: "labelsonline", key: "length"},
                {namespace: "labelsonline", key: "shape"},
                {namespace: "labelsonline", key: "perforated"},
                {namespace: "labelsonline", key: "labels_per_sheet"},
                {namespace: "labelsonline", key: "word-link"},
                {namespace: "labelsonline", key: "pdf-link"}
            ]) {
                key
                value
            }
        }
    }
    }
}`;

            const graphql = JSON.stringify({
                query: query,
                variables: { after: after }
            })
            const requestOptions = {
                method: "POST",
                headers: lolHeaders,
                body: graphql,
                redirect: "follow"
            };

            fetch("https://labelsonline-com.myshopify.com/api/2025-01/graphql.json", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if(result && result.hasOwnProperty('data')
                        && result.data
                        && result.data.hasOwnProperty('products')
                        && result.data.products
                        && result.data.products.hasOwnProperty('edges')
                        && result.data.products.edges.length
                    ) {
                        const products = result.data.products.edges;
                        products.forEach((edge) => {
                            const product = edge.node;
                            const label = {
                                id: parseInt(product.id.replace('gid://shopify/Product/','')),
                                handle: product.handle,
                                title: product.title,
                                description: product.descriptionHtml,
                                image: product.featuredImage,
                                width: this.getTemplateMetafieldValue(product,'width'),
                                length: this.getTemplateMetafieldValue(product,'length'),
                                shape: this.getTemplateMetafieldValue(product,'shape'),
                                perforated: this.getTemplateMetafieldValue(product,'perforated'),
                                labels_per_sheet: this.getTemplateMetafieldValue(product,'labels_per_sheet'),
                                pdf_link: this.getTemplateMetafieldValue(product,'pdf-link'),
                                word_link: this.getTemplateMetafieldValue(product,'word-link')
                            };
                            for(const filter in this.filters){
                                if(label[filter] && !this.filters[filter].includes(label[filter])) {
                                    this.filters[filter].push(label[filter]);
                                }
                            }
                            this.labels.push(label);
                        });
                        const pageInfo = result.data.products.pageInfo;
                        if(pageInfo && pageInfo.hasNextPage && pageInfo.endCursor) {
                            this.getLabels(pageInfo.endCursor);
                        }
                    }
                })
                .catch((error) => console.error(error));
        },
        getTemplateMetafieldValue(node, key) {
            const field = node.metafields.find(m => m && m.key === key);
            return field ? field.value : "";
        }
    }
}, { ...blankLaserTemplatesEl.dataset });
if(blankLaserTemplatesEl) {
    blankLaserTemplatesApp.mount('#blank_laser_templates');
}
